<template>
    <section>
        <level>
            <ul>
                <li
                    v-for="(title, index) in titleStack"
                    :key="index"
                    class="title-stack-item inline-block text-gray-400 dark:text-gray-400">
                    {{ title }}
                </li>
            </ul>
        </level>
    </section>
</template>

<script>
    import { mdiGithub } from '@mdi/js'
    import Level from '@/components/Level'

    export default {
        name: 'TitleBar',
        components: {
            Level
        },
        props: {
            titleStack: {
                type: Array,
                default: () => []
            }
        },
        setup () {
            return {
                mdiGithub
            }
        }
    }
</script>

<style scoped>
    li.title-stack-item:not(:last-child):after {
        content: '>';
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        /* background-color: red; */
    }
    ul {
      /* border: 2px solid #FD841F; */
      /* background: linear-gradient(30deg, #fc806d, #ffe047); */
      /* color: white; */
      /* padding: 4px 16px; */
      border-radius: 0px;
    }
    li {
      font-size: 16px !important;
      /* color: white; */
    }
    li:nth-last-child(1) {
      /* color: #FD841F; */
      font-weight: 800;
    }
    /* li:nth-last-child(n + 2)::after {
        content: '>';
        font-weight: 400 !important;
        @apply inline-block ml-2;
    } */
</style>
